<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
            /* Estilos generales */
            .ib-layout__section {
                margin: 0 auto;
                overflow: hidden;

                /* Ancho máximo para contener el contenido */
            }

            @media (max-width: 425px) {
                .ib-box-promo__description.ib-box-promo__description--extra-padding.clearfix {
                    padding-bottom: 10px;
                    padding-left: 10px;
                    padding-right: 10px;
                }

                #pmt-confirmation-more-cf-info-btn {
                    width: 270px;
                }
            }

            /* Estilos para dispositivos de hasta 600px */
            @media (max-width: 600px) {
                #pmt-confirmation-more-cf-info-btn {
                    width: 428px;
                }

                .ib-box-promo__description.ib-box-promo__description--extra-padding.clearfix {
                    padding-bottom: 10px;
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }

            /* Estilos para dispositivos de 600 a 768px */
            @media (min-width: 601px) and (max-width: 767px) {
                #pmt-confirmation-more-cf-info-btn {
                    width: 400px;
                }
                .ib-box-promo__description.ib-box-promo__description--extra-padding.clearfix {
                    padding-bottom: 10px;
                }
            }


            @media (min-width: 768px){
                .ib-box-promo__title {
                    font-size: 18px;
                    line-height: 20px;

                }

                .ib-box-promo__image {
                    width: 36rem;
                }

                .ib-box-promo__wrapper {
                    height: 168px;
                }
            }
            /* Estilos para dispositivos de 768 a 1024px */
            @media (min-width: 769px) and (max-width: 1024px) {
                #pmt-confirmation-more-cf-info-btn {
                    width: 150px;
                    margin-top: -25px;
                }
                .ib-box-promo__image {
                    width: 36rem;
                }

                .ib-box-promo__title {
                    font-size: 27px;
                    line-height: 27px;
                }

                .ib-box-promo__wrapper {
                    height: 168px;
                }
            }

            /* Estilos para dispositivos de más de 1024px */
            @media (min-width: 1025px) {
                #pmt-confirmation-more-cf-info-btn {
                    width: 200px;
                    margin-top: -30px;
                }

                .ib-box-promo__image {
                    width: 46.9375rem;
                }

                .ib-box-promo__title {
                    font-size: 29px;
                    line-height: 35px;
                }
                .custom-banner-image{
                    margin-top: -10px;
                }
                .ib-box-promo__wrapper {
                    height: 192px;
                }
            }

            @media (min-width: 1900px) {
                .ib-box-promo__title {
                    font-size: 32px;
                    line-height: 35px;
                }

                .custom-banner-image{
                    margin-top: -10px;
                }
                .ib-box-promo__wrapper {
                    height: 192px;
                }
            }
        </style>
    </head>
    <body>
        <div class="ib-layout__section ib-layout__section--medium">
            <div class="ib-box-promo ib-box-promo--carbon ib-box-promo--medium ib-box-promo--responsive u-height-auto-sm">
                <div class="ib-box-promo__wrapper">
                    <div class="ib-box-promo__image">
                        <figure class="ib-box-promo__figure ib-box-promo__figure--relative">
                            <img src="{{ baseImagePath }}/banners/saf-redesign.png" alt="ANCILLARIES_CO2_FOOTPRINT_1_5_BANNER_TITLE" class="custom-banner-image" />
                        </figure>
                    </div>
                    <div class="ib-box-promo__description ib-box-promo__description--extra-padding clearfix">
                        <span class="ib-box-promo__title" style="max-height: fit-content; border-bottom: none; padding: 0; margin: 0">
                            {{ "CO2_BANNER_TITTLE" | translate }}
                            <br />
                        </span>
                        <div class="ib-box-promo__description-text ib-box-promo__description-text--full"></div>
                        <div class="ib-box-promo__description-button u-mt">
                            <a href="{{ choooseUrl }}" target="_blank" class="ib-box-promo__description-button-sustainability--link">
                                <button
                                    id="pmt-confirmation-more-cf-info-btn"
                                    style="background-color: #d7192d"
                                    class="ib-button ib-button-- ib-button--w-small ib-button--block-sm"
                                >
                                    {{ "CO2_BANNER_BUTTON" | translate }}
                                </button>
                            </a>
                            <a href="{{ 'UPGRADE_IBERIA_ZERO' | link }}"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
